import {extend, getIntersection, intersects} from 'ol/extent';

export const enhancedMosaic = mosaic => {
  const isAnalytic = mosaic.datatype === 'uint16';
  return {
    ...mosaic,
    hasAccess: Boolean(mosaic._links?.tiles), // no tiles link implies no access
    bands: isAnalytic ? ['b', 'g', 'r', 'nir', 'a'] : ['r', 'g', 'b', 'a'],
    pixelDepth: isAnalytic ? 10000 : 256,
    supports: {
      indexes: isAnalytic,
      numpy: true,
    },
  };
};

export const calcEffectiveExtent = (mosaic, rules) => {
  // filter down to rules with extents
  const extents = rules.filter(rule => !!rule.extent).map(rule => rule.extent);
  let extent;
  if (extents.length > 0) {
    extent = [...extents[0]];
    for (let i = 1, ii = extents.length; i < ii; i++) {
      // `extend` modifies extent, creating a side effect.
      extend(extent, extents[i]);
    }
  }

  if (mosaic) {
    // in rare cases the mosaic's intersection and
    //  the extent rules are mismatched, this prevents an error state.
    if (extent && intersects(mosaic.bbox, extent)) {
      return getIntersection(mosaic.bbox, extent);
    }
    return mosaic.bbox;
  }
};

export const rulesForMosaic = (rules, mosaicName) => {
  if (Array.isArray(rules)) {
    return rules.filter(
      rule =>
        rule.ids && (rule.ids[0] === '*' || rule.ids.indexOf(mosaicName) >= 0)
    );
  }

  return [];
};
